var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaUrlaubsliste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f5fb;}.cls-2{opacity:0.97;}.cls-3{fill:#8b94a3;}.cls-4{fill:#ffd15c;}.cls-5{fill:#ffc14c;}.cls-6{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.32,152H34.11a2.87,2.87,0,0,1-2.72-3V11a2.87,2.87,0,0,1,2.72-3h92.21A2.87,2.87,0,0,1,129,11V149A2.87,2.87,0,0,1,126.32,152Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.06,94.85H58.37a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.49h55.69a2.48,2.48,0,0,1,2.48,2.49h0A2.48,2.48,0,0,1,114.06,94.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.65,140.1H58.37a2.48,2.48,0,0,1-2.48-2.49h0a2.48,2.48,0,0,1,2.48-2.48h50.28a2.48,2.48,0,0,1,2.49,2.48h0A2.48,2.48,0,0,1,108.65,140.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.45,109.93H58.37a2.48,2.48,0,0,1-2.48-2.48h0A2.48,2.48,0,0,1,58.37,105H92.45a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,92.45,109.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.45,125H58.37a2.48,2.48,0,0,1-2.48-2.48h0a2.48,2.48,0,0,1,2.48-2.48H92.45a2.48,2.48,0,0,1,2.48,2.48h0A2.48,2.48,0,0,1,92.45,125Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.8,94.85H47a2.48,2.48,0,0,1-2.48-2.48h0A2.48,2.48,0,0,1,47,89.88H48.8a2.49,2.49,0,0,1,2.49,2.49h0A2.49,2.49,0,0,1,48.8,94.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.8,109.93H47a2.48,2.48,0,0,1-2.48-2.48h0A2.48,2.48,0,0,1,47,105H48.8a2.49,2.49,0,0,1,2.49,2.48h0A2.49,2.49,0,0,1,48.8,109.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.8,125H47a2.48,2.48,0,0,1-2.48-2.48h0A2.48,2.48,0,0,1,47,120.05H48.8a2.49,2.49,0,0,1,2.49,2.48h0A2.49,2.49,0,0,1,48.8,125Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.8,140.1H47a2.48,2.48,0,0,1-2.48-2.49h0A2.48,2.48,0,0,1,47,135.13H48.8a2.49,2.49,0,0,1,2.49,2.48h0A2.49,2.49,0,0,1,48.8,140.1Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.21,
    cy: 49.71,
    r: 17.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.45,34.37A28.8,28.8,0,0,1,89.81,42c.45,10.51-6.65,19.8-15.87,23.88a17.61,17.61,0,0,0,6.27,1.21,17.4,17.4,0,0,0,8.24-32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.21,19.49a2.55,2.55,0,0,0-2.57,2.57v4.23a2.57,2.57,0,0,0,5.14,0V22.06A2.54,2.54,0,0,0,80.21,19.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.21,70.56a2.56,2.56,0,0,0-2.57,2.57v4.23a2.57,2.57,0,0,0,5.14,0V73.13A2.55,2.55,0,0,0,80.21,70.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.43,49.71a2.54,2.54,0,0,0-2.56-2.57h-4.24a2.57,2.57,0,0,0,0,5.14h4.24A2.55,2.55,0,0,0,110.43,49.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.36,49.71a2.55,2.55,0,0,0-2.57-2.57H52.56a2.57,2.57,0,0,0,0,5.14h4.23A2.56,2.56,0,0,0,59.36,49.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.59,28.33a2.58,2.58,0,0,0-3.62,0l-3,3A2.56,2.56,0,1,0,98.57,35l3-3A2.58,2.58,0,0,0,101.59,28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.48,64.44a2.61,2.61,0,0,0-3.63,0l-3,3a2.56,2.56,0,1,0,3.63,3.62l3-3A2.61,2.61,0,0,0,65.48,64.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.59,71.09a2.58,2.58,0,0,0,0-3.62l-3-3A2.56,2.56,0,1,0,95,68.07l3,3A2.6,2.6,0,0,0,101.59,71.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.48,35a2.61,2.61,0,0,0,0-3.63l-3-3A2.56,2.56,0,1,0,58.83,32l3,3A2.61,2.61,0,0,0,65.48,35Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 160,
    height: 160,
    rx: 8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaUrlaubsliste);
export default __webpack_public_path__ + "static/media/ka_urlaubsliste.8f76edeb27c1ff8711919890cf6ccf0a.svg";
export { ForwardRef as ReactComponent };